// Get the necessary elements
const addButton = document.querySelector('.js-add-partner');
const removeButtons = document.querySelectorAll('.js-remove-partner');
const totalPartnerId = document.getElementById(
  'id_partner_organizations-TOTAL_FORMS'
);

function getFieldWrapper(input) {
  return input ? input.closest('.fieldInputWrapper') : null;
}

function setFieldError(input, message) {
  const fieldWrapper = getFieldWrapper(input);

  if (!fieldWrapper) {
    return;
  }

  const errorWrapper = fieldWrapper.nextElementSibling
    ? fieldWrapper.nextElementSibling.closest('.fieldErrorWrapper')
    : null;

  fieldWrapper.classList.add('error');

  if (errorWrapper) {
    errorWrapper.textContent = message;
    errorWrapper.classList.add('error');
  }
}

function clearFieldError(input) {
  const fieldWrapper = getFieldWrapper(input);

  if (!fieldWrapper) {
    return;
  }

  const errorWrapper = fieldWrapper.nextElementSibling
    ? fieldWrapper.nextElementSibling.closest('.fieldErrorWrapper')
    : null;

  fieldWrapper.classList.remove('error');

  if (errorWrapper) {
    errorWrapper.textContent = '';
    errorWrapper.classList.remove('error');
  }
}

function validateField(input, validator, message) {
  const isValid =
    typeof validator === 'function' ? validator(input) : validator;

  if (!input || !isValid) {
    setFieldError(input, message);
    return false;
  }

  clearFieldError(input);
  return true;
}

// Add event listener to the add button
if (addButton) {
  addButton.addEventListener('click', function () {
    const partnerField = document.querySelector('.partner-field');

    if (!partnerField) {
      return;
    }

    const partnerInput = partnerField
      ? partnerField.querySelector('input[name$="-name"]')
      : null;
    const partnerContactNameInput = partnerField
      ? partnerField.querySelector('input[name$="-contact_name"]')
      : null;
    const partnerEmailInput = partnerField
      ? partnerField.querySelector('input[name$="-email"]')
      : null;

    if (
      !validateField(
        partnerInput,
        input => input.checkValidity(),
        'This field is required.'
      )
    ) {
      return;
    }

    if (
      !validateField(
        partnerContactNameInput,
        input => Boolean(input.value.trim()),
        'This field is required.'
      )
    ) {
      return;
    }

    if (
      !validateField(
        partnerEmailInput,
        input => Boolean(input.value.trim()),
        'This field is required.'
      )
    ) {
      return;
    }

    if (
      !validateField(
        partnerEmailInput,
        input => input.checkValidity(),
        'Please enter a valid email address.'
      )
    ) {
      return;
    }

    addPartner(false);
  });
}

if (removeButtons.length > 0) {
  // Iterate over each element
  for (let i = 0; i < removeButtons.length; i++) {
    // Add click event listener to each element
    removeButtons[i].addEventListener('click', function (event) {
      removePartner(event.target);
    });
  }
}

// Function to handle the click event
export default function addPartner(partner, ldatId, previousLdatId) {
  const partnersDiv = document.querySelector('.partners');
  const partnerField = document.querySelector('.partner-field');
  let partnerCount = parseInt(totalPartnerId.value);
  const cap = document.getElementById('current-cap-id');
  const capId = cap.value;
  // Create the new partner element
  const partnerDiv = document.createElement('div');
  let partnerName;
  let updatedString;
  let partnerInput = partnerField
    ? partnerField.querySelector('input[name$="-name"]')
    : null;
  const partnerContactNameInput = partnerField
    ? partnerField.querySelector('input[name$="-contact_name"]')
    : null;
  const partnerEmailInput = partnerField
    ? partnerField.querySelector('input[name$="-email"]')
    : null;
  const partnerPhoneInput = partnerField
    ? partnerField.querySelector('input[name$="-phone"]')
    : null;
  let contactName = '';
  let email = '';
  let phone = '';

  if (partner) {
    // if it is called from ldatSelection
    partnerName = partner.account_name.trim();
    contactName = partner.contact_name || '';
    email = partner.email || '';
    phone = partner.phone || '';

    //Remove partner that is shown from SF
    if (ldatId !== previousLdatId) {
      const partnerElements = document.querySelectorAll('.partners .current');
      partnerElements.forEach(partnerElement => {
        const btnRemove = partnerElement.querySelector('.btn-remove');

        if (btnRemove) {
          btnRemove.click();
        }
      });
    }

    const existingPartnerElements = document.querySelectorAll(
      '.partners .js-partner'
    );

    // Check if partnerName already exists in existingPartnerElements
    const partnerNamesArray = Array.from(existingPartnerElements).map(el =>
      el.textContent.trim()
    );

    if (partnerNamesArray.includes(partnerName)) {
      return false;
    }
    partnerDiv.classList.add('current');
  } else if (partnerInput) {
    partnerName = partnerInput.value.trim();
    contactName = partnerContactNameInput
      ? partnerContactNameInput.value.trim()
      : '';
    email = partnerEmailInput ? partnerEmailInput.value.trim() : '';
    phone = partnerPhoneInput ? partnerPhoneInput.value.trim() : '';
  }

  if (partnerName) {
    updatedString = partnerInput.name.replace(
      '__prefix__-name',
      `${partnerCount - 1}`
    );
    partnerDiv.classList.add('chip');

    const partnerNameSpan = document.createElement('span');
    partnerNameSpan.textContent = partnerName;

    const removeButton = document.createElement('button');
    removeButton.type = 'button';
    removeButton.classList.add('btn-remove');
    removeButton.setAttribute('aria-label', `remove ${partnerName}`);

    // Append the partner name and remove button to the partner div
    partnerDiv.appendChild(partnerNameSpan);
    partnerDiv.appendChild(removeButton);

    // Append the partner div to the partners container
    partnersDiv.appendChild(partnerDiv);

    // Create the hidden input field with the increased value
    const hiddenInput = document.createElement('input');
    const hiddenNameInput = document.createElement('input');
    const hiddenContactNameInput = document.createElement('input');
    const hiddenEmailInput = document.createElement('input');
    const hiddenPhoneInput = document.createElement('input');
    const hiddenCapInput = document.createElement('input');
    hiddenInput.type = 'hidden';
    hiddenInput.name = `${updatedString}-id`;
    hiddenInput.id = `id_${updatedString}-id`;
    hiddenNameInput.type = 'hidden';
    hiddenNameInput.name = `${updatedString}-name`;
    hiddenNameInput.id = `id_${updatedString}-name`;
    hiddenNameInput.value = partnerName;
    hiddenContactNameInput.type = 'hidden';
    hiddenContactNameInput.name = `${updatedString}-contact_name`;
    hiddenContactNameInput.id = `id_${updatedString}-contact_name`;
    hiddenContactNameInput.value = contactName;
    hiddenEmailInput.type = 'hidden';
    hiddenEmailInput.name = `${updatedString}-email`;
    hiddenEmailInput.id = `id_${updatedString}-email`;
    hiddenEmailInput.value = email;
    hiddenPhoneInput.type = 'hidden';
    hiddenPhoneInput.name = `${updatedString}-phone`;
    hiddenPhoneInput.id = `id_${updatedString}-phone`;
    hiddenPhoneInput.value = phone;
    hiddenCapInput.type = 'hidden';
    hiddenCapInput.name = `${updatedString}-cap`;
    hiddenCapInput.id = `id_${updatedString}-cap`;
    hiddenCapInput.value = capId;

    removeButton.addEventListener('click', function () {
      partnerDiv.remove();
      hiddenInput.remove();
      hiddenCapInput.remove();
      hiddenNameInput.remove();
      hiddenContactNameInput.remove();
      hiddenEmailInput.remove();
      hiddenPhoneInput.remove();
      partnerCount--;
      // Update the partner field's value
      totalPartnerId.value = partnerCount;
    });

    // Append the hidden input field to the partner div
    partnerDiv.appendChild(hiddenInput);
    partnerDiv.appendChild(hiddenCapInput);
    partnerDiv.appendChild(hiddenNameInput);
    partnerDiv.appendChild(hiddenContactNameInput);
    partnerDiv.appendChild(hiddenEmailInput);
    partnerDiv.appendChild(hiddenPhoneInput);

    // Update the input field's value
    partnerCount++;
    totalPartnerId.value = partnerCount;
    // Clear the input field
    if (partnerInput) {
      partnerInput.value = '';
    }
    if (partnerContactNameInput) {
      partnerContactNameInput.value = '';
    }
    if (partnerEmailInput) {
      partnerEmailInput.value = '';
    }
    if (partnerPhoneInput) {
      partnerPhoneInput.value = '';
    }
  }
}

function removePartner(btn) {
  let partnerId = btn.getAttribute('data-partner-id'); // Get the data-partner-id attribute value
  let hiddenInput = document.querySelector(
    'input[name^="partner_organizations"][value="' + partnerId + '"]'
  ); // Find the hidden input with the partner ID value
  let hiddenInputName = hiddenInput.name;
  let hiddenInputs = document.querySelectorAll(
    'input[name^="' + hiddenInputName.replace(/id$/, '') + '"]'
  );
  let partnerCount = parseInt(totalPartnerId.value);
  btn.closest('.js-partner').remove();
  partnerCount--;
  // // Update the total partner field's value
  totalPartnerId.value = partnerCount;

  if (hiddenInputs.length > 0) {
    hiddenInputs.forEach(function (input) {
      input.remove();
    });
  }
}
